<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <br>
        <div class="row">
          <form class="col s12">
            <div class="row">
              <div class="input-field col s12">
                <i class="material-icons prefix splash-cor-1 ">person</i>
                <input id="icon_prefix" type="text" class="validate splash-cor-1" disabled v-bind:value="cliente.nome">
              </div>
              <div class="input-field col s12">
                <i class="material-icons prefix splash-cor-1">phone</i>
                <input id="icon_telephone" type="tel" class="validate splash-cor-1" disabled v-bind:value="cliente.telefone">
              </div>
            </div>
          </form>
        </div>
        <div v-if="podeAcompanharPedidos" class="btn waves-effect waves-light cor-primaria-bg" @click="UltimosPedidos()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('meus_pedidos') }}
            </div>
          </div>
        </div>
        <br>
        <div class="btn waves-effect waves-light red" @click="Sair()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Deslogar de sua conta
            </div>
          </div>
        </div>
        <div style="height: 500px;"></div>
      </div>
    </div>
    <meu-login-bloco-flutuante-component></meu-login-bloco-flutuante-component>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import {Logout, ObterClienteLogado} from "../../../services/auth";
import MeuLoginBlocoFlutuanteComponent from "../../Widgets/MeuLoginBlocoFlutuanteComponent";
import axios from "axios";

export default {
  name: "PerfilCliente",
  data(){
    return {
      cliente:{
        nome:"",
        email:"",
        telefone:"",
        isLoading: false
      },
      lastError: null,
      empresaExiste: false,
      isLoading: false
    }
  },
  computed: {
    podeAcompanharPedidos() {
      const empresa = this.$store && this.$store.state ? this.$store.state.empresa : null;
      const flag = empresa ? empresa.desativar_acompanhar_ultimo_pedido : null;
      return String(flag || "N").trim().toUpperCase() !== "S";
    }
  },
  components: {
    MeuLoginBlocoFlutuanteComponent,
    LogoEmpresa,
    NavBarOnly
  },
  mounted() {
    this.VerificarEmpresa();
    window.scrollTo(0, 0);
    ObterClienteLogado().then(res=>{
      this.cliente = res;
    }).catch(err=>{
      console.log('erro')
    });
  },
  methods: {
    async VerificarEmpresa() {
      this.isLoading = true;
      this.$store.commit("empresaUrl", this.$router.currentRoute.params.empresa);
      
      const buscarEmpresa = async (tentativa = 1) => {
        try {
          const res = await axios.get(
            this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url
          );
          
          if (res.data) {
            this.$store.commit("empresa", res.data);
            this.empresaExiste = true;
            this.isLoading = false;
            return true;
          }
          return false;
        } catch (error) {
          if (tentativa < 5) {
            console.log(`Tentativa ${tentativa} de buscar empresa falhou, tentando novamente em 1.5s...`, error.response && error.response.status);
            await new Promise(resolve => setTimeout(resolve, 1500));
            return buscarEmpresa(tentativa + 1);
          }
          this.lastError = error;
          this.isLoading = false;
          return false;
        }
      };

      const sucesso = await buscarEmpresa();

      if (!sucesso && !this.empresaExiste) {
        let reason = this.lastError ? (this.lastError.message || this.lastError) : 'Unknown';
        if (this.lastError && this.lastError.response) {
            reason += ` (Status: ${this.lastError.response.status})`;
        }
        reason += ` | Slug: ${this.$store.state.empresa_url}`;
        this.$router.push({
          path: '/404/nao-localizado',
          query: { retryPath: this.$route.fullPath, reason: reason }
        });
      }
    },
    async Sair() {
      await Logout();
      this.$router.push("/" + this.$store.state.empresa_url);
    },
    UltimosPedidos() {
      if (!this.podeAcompanharPedidos) return;
      this.$router.push("/" + this.$store.state.empresa_url + "/cliente-pedidos");
    }
  }
};
</script>

<style scoped>
@import '../../../assets/css/conteudo-splash.css';
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/PerfilCliente.vue